import { exec } from 'child_process';

export function launchChrome(url: string) {
    const { platform } = process;

    if (platform === 'win32') {
        exec(`start chrome ${url}`);
    } else if (platform === 'darwin') {
        exec(`open -a "Google Chrome" ${url}`);
    } else if (platform === 'linux') {
        exec(`google-chrome ${url}`);
    }
}
